import { ButtonHeading, CommonInput, CommonModal } from "components";
import React, { useState, useEffect } from "react";
import "../../assets/css/setting.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getEnvironment, updateEnvironment } from "features";
import {
  resetError,
  resetUpdateSuccess,
} from "features/settingService/settingSlice";
import CommonButton from "components/common/CommonButton";
import { utils, errorSchema } from "helper";
import toast from "react-hot-toast";

const Setting = () => {
  const dispatch = useDispatch();
  const { data, loading, error, updateSuccess } = useSelector(
    (state) => state?.setting
  );
  const [activeToggle, setActiveToggle] = useState(null); // 1 for production, 2 for staging
  const [form, setForm] = useState({
    productionUrl: "",
    stagingUrl: "",
    productionVersion: "",
    stagingVersion: "",
  });
  const [formError, setFormError] = useState("");

  useEffect(() => {
    dispatch(getEnvironment());
  }, [dispatch]);

  useEffect(() => {
    if (data?.data?.master_data) {
      const masterData = data.data.master_data;
      setForm({
        productionUrl: masterData.production_api_url,
        stagingUrl: masterData.staging_api_url || "",
        productionVersion: masterData.production_app_version || "",
        stagingVersion: masterData.staging_app_version || "",
      });
      setActiveToggle(masterData.env_switch === 1 ? 1 : 2);
    }
  }, [data]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(resetUpdateSuccess());
      dispatch(getEnvironment());
    }
    if (error) {
      console.error("API Error:", error);
      dispatch(resetError());
    }
  }, [updateSuccess, error, dispatch]);

  const handleOnChange = (name, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleToggle = (value) => {
    setActiveToggle(value);
  };

  const handleSubmitupdate = async () => {
    const validationResult = await utils.checkFormError(
      form,
      errorSchema.environmentSettingsSchema
    );
    if (validationResult === true) {
      const environmentParams = {
        production_api_url: form.productionUrl,
        staging_api_url: form.stagingUrl,
        production_app_version: form.productionVersion,
        staging_app_version: form.stagingVersion,
        env_switch: activeToggle, // 1 or 2 based on toggle
      };

      dispatch(updateEnvironment(environmentParams));
      toast.success("Settings saved successfully!");
    } else {
      setFormError(validationResult);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitupdate();
  };

  const setVh = () => {
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight * 0.01}px`
    );
  };

  window.addEventListener("resize", setVh);
  setVh();
  return (
    <>
      <ButtonHeading title="Environment Settings" />
      <form onSubmit={handleSubmit}>
        <div className="settings-container anv_fr_detailHead _tabWith_outTab">
          <div className="settings-section _divider">
            <div className="common-input-container url-input ">
              <CommonInput
                type="text"
                label="Production"
                placeholder="Enter Production Url"
                name="productionUrl"
                value={form.productionUrl}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                error={formError?.productionUrl}
              />
            </div>

            <div className="common-input-container version-input">
              <CommonInput
                type="text"
                label="Application Version"
                placeholder="1.2.6"
                name="productionVersion"
                value={form.productionVersion}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                error={formError?.productionVersion}
              />
            </div>

            <div
              className="_anvSwitcherNew form-check form-switch _toggle_btn"
              style={{ width: "125px" }}
            >
              <input
                className="form-check-input _pi_ter"
                type="checkbox"
                name="productionToggle"
                checked={activeToggle === 1}
                onChange={() => handleToggle(1)} // Set to 1 for production
              />
            </div>
          </div>

          <div className="settings-section _divider">
            <div className="common-input-container url-input">
              <CommonInput
                type="text"
                label="Staging"
                placeholder="Enter Staging Url"
                name="stagingUrl"
                value={form.stagingUrl}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                error={formError?.stagingUrl}
              />
            </div>

            <div className="common-input-container version-input">
              <CommonInput
                type="text"
                label="Application Version"
                placeholder="1.2.5"
                name="stagingVersion"
                value={form.stagingVersion}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
                error={formError?.stagingVersion}
              />
            </div>

            <div
              className="_anvSwitcherNew form-check form-switch _toggle_btn"
              style={{ width: "125px" }}
            >
              <input
                className="form-check-input _pi_ter"
                type="checkbox"
                name="stagingToggle"
                checked={activeToggle === 2}
                onChange={() => handleToggle(2)} // Set to 2 for staging
              />
            </div>
          </div>

          {/* <div className="_btns">
            
          </div> */}
        </div>

        <div className="paginationFt_avt gap-2 justify-content-start py-2">
          <CommonButton
            buttonTitle={"Save"}
            className="_submit_btn _addComm_btn anime-btn"
            type="submit"
          />

          <CommonButton
            buttonTitle={"Cancel"}
            className="_cancel_btn _addComm_btn anime-btn"
            type="button"
          />
        </div>
      </form>
    </>
  );
};

export default Setting;
